import { NgModule, LOCALE_ID } from '@angular/core';
import es from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy, Platform } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { ToastController } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Drivers } from '@ionic/storage';
import { IonicStorageModule } from '@ionic/storage-angular';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { BarcodeScanner } from '@awesome-cordova-plugins/barcode-scanner/ngx';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
//import { TextoPipe } from './pipes/texto.pipe';
//import { Ng2SearchPipeModule } from 'ng2-search-filter';
//import { FileUploadModule } from 'ng2-file-upload';
registerLocaleData(es);

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, IonicModule.forRoot(), AppRoutingModule,HttpClientModule, FormsModule,
    ReactiveFormsModule,ZXingScannerModule,IonicStorageModule.forRoot({
      name: '_ionicstorage', storeName: 'leman',
      driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage]
    }), ServiceWorkerModule.register('ngsw-worker.js', {
  enabled: environment.production,
  registrationStrategy: 'registerWhenStable:30000'
})],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },ToastController, Platform, BarcodeScanner, {provide: LOCALE_ID,
    useValue: 'es-ES'}],
  bootstrap: [AppComponent],
})
export class AppModule {}
